/*
    The component displays a gallery of the ompany profile.

    In fact, it's a wrapper around the Lingallery component, since it requires a certain format of items and we have to convert our data
    Also, if we decide to change the underlying gallery implementation in the future, we can do so without affecting the rest of the application.
*/

<template>
    <div>
        <lingallery :iid.sync="currentId" :width="width" :height="height" :items="items"/>
    </div>

</template>

<script>
import Lingallery from 'lingallery';

export default {

  name: "ProfileGallery",

  props: {
    directoryGallery: { type: Array, required: true },
  },

  data() {
      return {
        width: 600,
        height: 400,
        items: this.convertProfileGalleryToComponent(this.directoryGallery),
        }
    },

  components: {
    Lingallery
  },

  methods: {
    convertProfileGalleryToComponent(profileGallery) {

        if (!(profileGallery && profileGallery.length > 0)) {
            return [];
        }

        const transformedArray = profileGallery.map(imageInfo => {
            return {
                src: imageInfo.url,
                thumbnail: imageInfo.url,
                caption: imageInfo.title,
                // id: imageInfo.id
            };
        });
        return transformedArray;
    }
  }

}

</script>

<style scoped>

    .file-list {
    }

</style>